import { DECIMAL_PLACES, DECIMAL_PLACES_PERCENTAGE } from 'constants/calcConstants'
import Decimal from 'decimal.js'

export const bankRoundingCeil = (num: number, decimalScale: number) =>
  new Decimal(num).toDecimalPlaces(decimalScale, Decimal.ROUND_CEIL).toNumber()
export const bankRounding = (num: number, decimalScale: number) =>
  new Decimal(num).toDecimalPlaces(decimalScale, Decimal.ROUND_HALF_EVEN).toNumber()
export const bankRoundingAwayFromZero = (num: number, decimalScale: number) =>
  new Decimal(num).toDecimalPlaces(decimalScale, Decimal.ROUND_CEIL).toNumber()
export const bankRoundingDecimal = (num: number, decimalScale: number) =>
  new Decimal(num).toDecimalPlaces(decimalScale, Decimal.ROUND_HALF_EVEN)

export const bankRoundingAmount = (num: number) => bankRounding(num, DECIMAL_PLACES)

export const mathRounding = (value: number, scale: number): number => {
  if (!value) return 0
  return Math.round(value * 10 ** scale + Number.EPSILON) / 10 ** scale
}

export const calcProportionInPercents = (from?: number, particle?: number): number => {
  if (!from || !particle) return mathRoundingPercentage(0)

  return mathRoundingPercentage((particle / from) * 100)
}

export const mathRoundingPercentage = (value?: number): number => {
  return value ? mathRounding(value, DECIMAL_PLACES_PERCENTAGE) : 0
}

export const mathRoundingAmount = (value?: number): number => {
  return value ? mathRounding(value, DECIMAL_PLACES) : 0
}

export const hasMoreDecimalPlaces = (num: number, decimalScale: number) => {
  return new Decimal(num).decimalPlaces() > decimalScale
}
